import React from 'react'
import { FormattedMessage } from 'react-intl'
import Tabs from '../common/layout/tabs.component'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'

const UserEditTabs = (props) => {

    const userEditLink = `/users/edit/${props.userId}`
    const notificationLink = `/users/notification-settings/edit/${props.userId}`
    const signatureLink = `/users/signature-settings/edit/${props.userId}`
    const passwordLink = `/users/password-settings/edit/${props.userId}`
    const tabs = [
        {
            name: <FormattedMessage
                id="user_edit.tabs.my_account.details"
                defaultMessage="Details"
            />,
            link: userEditLink,
        },
        {
            name: <FormattedMessage
                id="user_edit.tabs.my_account.notification_settings"
                defaultMessage="Email Notifications"
            />,
            link: notificationLink,
        },
        {
            name: <FormattedMessage
                id="user_edit.tabs.my_account.signature_settings"
                defaultMessage="Signature"
            />,
            link: signatureLink,
        },
        {
            name: <FormattedMessage
                id="user_edit.tabs.my_account.password"
                defaultMessage="Password"
            />,
            link: passwordLink,
        },
    ]
    return (
        <Tabs
            value={tabs}
        />

    )

}

export default UserEditTabs;


// WEBPACK FOOTER //
// ./src/user/useredit.component.jsx